import {Column, Entity, PrimaryGeneratedColumn} from "typeorm";

@Entity()
export class ActionLog {

	@PrimaryGeneratedColumn()
  id?: number
  
  @Column()
  ip_address!: string

  @Column()
  user_email!: string

  @Column('datetime')
  timestamp!: Date;
  
  @Column()
  description!: string

  @Column()
  label!:string

  @Column()
  tariff!:string
	
}